import { createActionNamespace } from 'Modules/core/redux';


const configAction = createActionNamespace('config');

export const configActions = {
    get: configAction<void>('GET'),
    set: configAction('SET'),
};
